import { syncGoogleCalendar } from "../api/client";

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function isIncomplete(result) {
  return Boolean(result?.syncing) || result?.complete === false;
}

/**
 * Importa a agenda Google em fatias HTTP até concluir (ou até o teto de tentativas).
 * Cada fatia persiste cursor no servidor; o worker continua se a aba for fechada.
 */
export async function runGoogleCalendarSyncToCompletion({
  forceFullSync = false,
  onChunk,
  maxChunks = 80,
  pauseMs = 250,
} = {}) {
  let last = null;
  for (let i = 0; i < maxChunks; i += 1) {
    last = await syncGoogleCalendar({ forceFullSync: forceFullSync && i === 0 });
    onChunk?.(last, i);
    if (!isIncomplete(last)) {
      return { ...last, complete: true, syncing: false, background: false };
    }
    await sleep(pauseMs);
  }
  return { ...last, complete: false, syncing: true, background: true };
}
